<template>
    <div>
        <div>
            <br>
            <div class="k-wrap-card">
                Sub Total: <span class="k-tag-red">{{ invoiceDues.invoiceDues.totalRemainingFeeOfMonth | numberFormatted
                    }}</span>
                <Button type="success" @click="refreshPerMonth" icon="refresh" size="small" class="btn-refresh">
                    <span>Refresh</span>
                </Button>
            </div>
            <br>
            <div v-for="invoiceDue in invoiceDues.invoiceDues" :key="invoiceDue.id" class="k-wrap-card">
                <div v-if="invoiceDue[0].invoicedate !== undefined">
                    <div v-for="invoice in invoiceDue" :key="invoice.id" class="k-card">
                        <div>
                            <div class="col-1">{{ invoice.invoicedate | dateFormatted }}</div>
                            <div class="col-2">{{ invoice.markingheadercode }}</div>
                            <div class="col-3">{{ invoice.description }}</div>
                            <div class="col-4">
                                <div v-if="invoice.invoicedate != ''">
                                    <div v-if="invoice.notes">
                                        <div>
                                            <span
                                                v-if="(invoice.currency === 'SGD' || invoice.currency === 'BAHT') && invoice.currencyvalue <= 1"
                                                class="k-tag-blue">{{ invoice.remainingFee | currency }} ({{
                                                    invoice.remainingFeeIdr | numberFormatted }})</span>
                                            <span v-else class="k-tag-blue">{{ invoice.remainingFee | numberFormatted
                                                }}</span>
                                            <div class="tooltip" v-if="invoice.notes.length != 0">{{
                                                invoice.notes.length }}
                                                <span class="tooltiptext">
                                                    <span v-for="note in invoice.notes">
                                                        {{ note | notesFormatted }} <br>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span class="k-tag-blue">{{ invoice.remainingFee | numberFormatted }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5">
                                <span v-if="invoice.totalRemainingFee != ''" type="border" class="k-tag-green">{{
                                    invoice.totalRemainingFee | numberFormatted }}</span>
                            </div>
                            <div class="col-6">
                                <Input v-if="invoice.invoicedate != ''" v-model="invoice.newNotes"
                                    @on-change="emitNewNotes(invoice.id, invoice.newNotes)"
                                    placeholder="Tambah Keterangan"></Input>
                            </div>

                        </div>
                    </div>
                </div><br />
            </div>
        </div>
    </div>
</template>

<script>
// import cInvoiceUnSettledByMarkingdiv from '@/components/invoice/cInvoiceUnSettledByMarkingdiv'
const numeral = require('numeral');
import moment from 'moment'


export default {
    // components : {cInvoiceUnSettledByMarkingdiv},    
    props: {
        invoiceDues: Object
    },
    data: () => ({
        notes: Object
    }),
    methods: {
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("D MMM YYYY")
        },
        emitNewNotes: function (invoiceDueId, notes) {
            var newNotes = {
                'invoiceDueId': invoiceDueId,
                'notes': notes
            }
            this.$emit('onAddNotes', newNotes)
        },
        refreshPerMonth: function () {
            var month = this.invoiceDues.periodMonth;
            var years = this.invoiceDues.periodYear;
            var index = this.invoiceDues.index;

            this.$emit('getUnsettledDetail', month, years, index)
        }
    },
    created() {

        // this.formattingContainer();
    },
    filters: {
        notesFormatted: function (notes) {
            if (!notes) return '~'
            var noteHtml = ''
            let notePrettyDate = moment(notes.created_at).fromNow()
            noteHtml += notes.created_by + ' - ' + notePrettyDate + ' : ' + notes.notes

            return noteHtml
        },
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00')
        }
    }
}

</script>
<style>
.k-wrap-card {
    width: 100%;
    border: 1px solid #dddee1;
    border-color: #e9eaec;
    padding: 8px 12px;
    border-radius: 3px;
    margin-bottom: 12px;
}

.k-tag-red {
    border-radius: 2px;
    border: 1px solid red;
    border-color: red;
    padding: 3px 8px;
}

.k-tag-green {
    border-radius: 2px;
    border: 1px solid green;
    border-color: green;
    padding: 3px 8px;
}

.k-tag-blue {
    border-radius: 2px;
    border: 1px solid blue;
    border-color: blue;
    padding: 3px 8px;
}

.k-card {
    width: 100%;
    clear: both;
}

.col-1 {
    width: 10%;
    float: left;
}

.col-2 {
    width: 12%;
    float: left;
}

.col-3 {
    width: 20%;
    float: left;
}

.col-4 {
    width: 17%;
    float: left;
}

.col-5 {
    width: 20%;
    float: left;
}

.col-6 {
    width: 41%;
    float: left;
}

.tooltip {
    display: inline-block;
    background: red;
    color: white;
    padding: 2px 8px;
    border-radius: 50%;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 220px;
    background-color: #4e4e4e;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

.btn-refresh {
    float: right;
}
</style>


// WEBPACK FOOTER //
// cInvoiceUnSettledByPeriod.vue?04705d98